module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAT9JREFUeNrsmOENgjAQhcUJGIERGAE2YIRu4Apu0hGMEzACbuAIuMFZTU0MSrm2T0rNveTCD+B4X2nherudSCQSiUSiDEREjQltojdxNFGB8iqbk+yx+4V5RZ8aTdSReTV9l0IDjDMPCoZwmH/mRQO45A2xYP6lZi0ALwimeYqdntOH9ggID/NX9BSqHOuABeFhfoSO/puBOhQiufkYiM2YD4Q4bcp8AMT2zIMh0pgHQaQ1HwmxDfMTiCTm96A8h5z3CTrn+a9z/gLpnP8BmnBa/S/sU9uo2Co2pfk6topNbh5RiiNbKlHzOSkEc/Q5W0ofiHLNPbHPpp4LwWpwcUuJs+PczURbFMWFk8he19r7XIJ2JcpHpwDc2Fp6Ex16HVSTtdADWotzEENOxWBpB2awb1lDF7BIJBKJ/lp3AQYAaID/xFpy8MIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/close-dialog@2x.png
// module id = 2322
// module chunks = 1